'use strict';

exports.__esModule = true;
var INVOICES = exports.INVOICES = {
  FETCH: 'FETCH_INVOICES',
  SUCCESS: 'FETCH_SUCCESS_INVOICES',
  FAIL: 'FETCH_FAIL_INVOICES'
};

var fetchInvoices = exports.fetchInvoices = function fetchInvoices(payload, userTimeZone) {
  return {
    type: INVOICES.FETCH,
    payload: payload,
    userTimeZone: userTimeZone
  };
};

var fetchInvoicesSuccess = exports.fetchInvoicesSuccess = function fetchInvoicesSuccess(payload) {
  return {
    type: INVOICES.SUCCESS,
    payload: payload
  };
};

var fetchInvoicesFail = exports.fetchInvoicesFail = function fetchInvoicesFail(payload) {
  return {
    type: INVOICES.FAIL,
    payload: payload
  };
};